import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'
import { LEGEND_COLOR_MAP_NEW } from '../../constants'

export const Wrapper = styled(Box)(`
    width:100%;
`)

export const Card = styled(Box)(
  (props) => `
    width: 260px;
    padding: 15px;
    background:#fff;
    position: relative;

    &:before {
        border: 12px transparent solid;
        border-right-color: #fff;
        content: '';
        position:absolute;
        left:-25px;
        top:10px;
    }

    ${
      props?.type === 'toolTip2' &&
      `
        // &:before{display:none;}
    `
    };

    &.segmentByDriversComponent .statsSection{
        border: none !important;
        padding-bottom: 0 !important;
        margin-bottom: 0 !important;
    }
`)

export const H3 = styled(Box)(`
    margin: -8px 0 0 0;
    font-size: 13px;
    font-weight: 400;
    color: #000;
    line-height: 1;
    min-height: 27px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;

    .percentValue {
        width: 50px;
        height:30px;
        line-height:30px;
    }
    .toolTipWrap {
        width: 170px;
        display: flex;
        flex-direction: column;
    }
    .toolTipHeading {
        font-size: 13px;
        font-weight: 600;
        color: #000;
    }
    .toolTipSubHeading {
        font-size: 11px;
        font-weight: 400;
        color: #454545;
        padding-top: 3px;
    }
`)

export const Para = styled(Box)(`
    margin: 0 0 5px;
    font-size: 12px;
    font-weight: 400; // 300;
    color: #6F6F6F;
    padding-left: 45px;
`)

export const Stats = styled(Box)(
  (props) => `
    display: flex;
    justify-content: space-between;
    margin: 10px 0;
    
    ${
      props?.dataLength > 0 &&
      `
        border-bottom: #EEE 1px solid;
        padding-bottom: 10px;
    `
    };

    & div { text-align: left; font-size: 14px; width:33%; position:relative; }
    & div:nth-of-type(1):after, & div:nth-of-type(2):after { position:absolute; top:0; left:90%; height:100%; border-right: 1px #EEE solid; content:''; }
`
)

export const Values = styled(Box)(
  (props) => `
    color: #000; font-size:20px; text-align:left;
    padding-right:10px;
    & strong {
        width:100%; display:block; color: ${LEGEND_COLOR_MAP_NEW[props.type]}; font-size:20px; font-weight: 400;
    }
    &.percentValue {
        font-size: 22px;
        font-weight: 400;
        color: #000;
    }
`
)

export const Row = styled(Box)(`
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 13px;
    margin: 5px 0 2px;
    color: #000;
`)

export const ProgressBar = styled(Box)(`
    width: 100%;
    height: 4px;
    border-bottom: 1px #eee solid;
    position: relative;
    border-radius: 2px;
    overflow: hidden;
    & span {
        display: block;
        height: 100%;
    }
`)
